import { render } from "./Login.vue?vue&type=template&id=68444e48&scoped=true&bindings={\"username\":\"setup\",\"password\":\"setup\",\"show\":\"setup\",\"toastMessage\":\"setup\",\"handleLogin\":\"setup\",\"handleRegisterClick\":\"setup\"}"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=68444e48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68444e48"

export default script